import { useQuery } from '@tanstack/react-query';
import {
  checkTenantSite,
  TenantCheckResponse,
  type TenantCheckPortal,
} from '@/services/tenants';

export const useTenantSiteCheck = (
  siteType: string | undefined,
  portal: TenantCheckPortal = 'clinic'
) => {
  return useQuery<TenantCheckResponse>({
    queryKey: ['tenants', 'check', siteType, portal],
    queryFn: () => checkTenantSite(siteType || '', portal),
    enabled: !!siteType,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
};
